import React from 'react';
import { AlertTriangle, Siren, HelpCircle, AlertCircle, ShieldAlert, BadgeDollarSign } from 'lucide-react';
import { SectionReveal, StaggerContainer, StaggerItem } from './SectionReveal';
export function ProblemSection() {
  const problems = [{
    icon: <HelpCircle className="w-8 h-8 text-[#DC2626]" data-id="element-208" />,
    text: 'Llevar el auto al taller y no entender qué te están explicando.'
  }, {
    icon: <Siren className="w-8 h-8 text-[#DC2626]" data-id="element-209" />,
    text: 'Escuchar un ruido extraño y no saber si es grave.'
  }, {
    icon: <BadgeDollarSign className="w-8 h-8 text-[#DC2626]" data-id="element-210" />,
    text: 'Pagar reparaciones sin saber si realmente eran necesarias.'
  }, {
    icon: <AlertCircle className="w-8 h-8 text-[#DC2626]" data-id="element-211" />,
    text: 'Ver una luz en el tablero y entrar en pánico.'
  }, {
    icon: <ShieldAlert className="w-8 h-8 text-[#DC2626]" data-id="element-212" />,
    text: 'Tener miedo de comprar un usado defectuoso.'
  }, {
    icon: <AlertTriangle className="w-8 h-8 text-[#DC2626]" data-id="element-213" />,
    text: 'Sentir que cualquier problema mecánico termina costándote demasiado dinero.'
  }];
  return <section className="py-20 md:py-32 bg-[#171717] border-b border-[#262626]" data-id="element-214">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-215">
        <SectionReveal className="text-center mb-16" data-id="element-216">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-217">
            ¿Te pasó alguna vez?
          </h2>
          <div className="w-24 h-1 bg-[#DC2626] mx-auto rounded-full" data-id="element-218"></div>
        </SectionReveal>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-219">
          {problems.map((problem, idx) => <StaggerItem key={idx} className="bg-[#0a0a0a] border border-[#262626] p-8 rounded-sm relative overflow-hidden group hover:border-[#DC2626]/50 transition-colors" data-id="element-220">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#DC2626]/5 rounded-full blur-3xl -mr-10 -mt-10 transition-opacity group-hover:opacity-100 opacity-0" data-id="element-221"></div>
              <div className="mb-6 relative z-10" data-id="element-222">{problem.icon}</div>
              <p className="text-[#F5F5F5] text-lg font-medium leading-snug relative z-10" data-id="element-223">
                {problem.text}
              </p>
            </StaggerItem>)}
        </StaggerContainer>

        <SectionReveal delay={0.2} className="max-w-3xl mx-auto text-center" data-id="element-224">
          <div className="p-8 border border-[#262626] bg-[#0a0a0a] rounded-sm" data-id="element-225">
            <p className="text-lg md:text-xl text-[#9CA3AF] leading-relaxed" data-id="element-226">
              La mayoría de las personas manejan todos los días un vehículo que
              prácticamente no conocen.
              <span className="block mt-3 text-white font-medium" data-id="element-227">
                Y ese desconocimiento suele transformarse en gastos
                innecesarios, malas decisiones y mucho estrés.
              </span>
            </p>
          </div>
        </SectionReveal>
      </div>
    </section>;
}